/**
 * @desc 参数监控查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ParamMonitorRequest,
): Promise<
  defs.StandardReturn<defs.ObjectMap<string, Array<defs.ParamMonitorResponse>>>
> {
  return defHttp.post({
    url: '/wap/ProductionRealTime/qryParamMonitor',
    data,
  });
}

export function mock(
  data: defs.ParamMonitorRequest,
): Promise<
  defs.StandardReturn<defs.ObjectMap<string, Array<defs.ParamMonitorResponse>>>
> {
  return defHttp.post({
    url: '/mock/wap/ProductionRealTime/qryParamMonitor',
    data,
  });
}
